export const isArrayOf = <T>(items: T[] | T): items is T[] => Array.isArray(items);

export const filterNullAndUndefined = <T>(item: T | undefined | null): item is T =>
  item !== null && item !== undefined;

export const removeDuplicates = <T>(array: T[]) => [...new Set(array)];

export const isNonEmptyArray = <T>(items: T | readonly T[]): items is NonEmptyArray<T> =>
  Array.isArray(items) && items.length > 0;

export const hasAtLeastTwoElements = <T>(items: T[] | T): items is [T, T, ...T[]] =>
  Array.isArray(items) && items.length >= 2;

export const isIn = <T>(x: any, values: readonly T[]): x is T => values.includes(x);
